<template>
    <div class="container mt-5">
        <h3 class="text-center mb-3">Sorumlu Olduğunuz Kişiler</h3>   
        
        <b-table :busy="isBusy"
                 :items="kisiler"
                 :fields="fields"
                 small
                 empty-text="Kayıt Bulunamadı"
                 show-empty
                 class="table-responsive-sm"
                 striped hover>
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Getiriliyor...</strong>
                </div>
            </template>
            <template v-slot:cell(islemler)="data">
                <b-btn variant="success" @click="kanaatEkleVeyaDuzenle(data.item.kisiId, data.item.kanaat, data.index)">Kanaat</b-btn>
                <b-btn variant="info" class="ml-3" @click="kartlarinaGit(data.item.kisiId)">Kartlarına Git</b-btn>
            </template>
        </b-table>
        <b-modal id="kanaatModal" title="Kanaat" ok-title="Kaydet" cancel-title="İptal Et"
        @ok="kanaatiKaydet">
            <b-form-textarea
                    id="textarea"
                    v-model="kanaat.metin"
                    placeholder="Kanaatinizi Belirtiniz..."
                    rows="5"
                    max-rows="10"
            ></b-form-textarea>
        </b-modal>
    </div>
</template>

<script>
    import {KisiyeKanaatEkle, SorumluOlunanKisileriGetir} from "@/api/kisi";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {mapGetters} from "vuex";

    export default {
        name: "SorumluOlunanKisiler",
        data() {
            return {
              isBusy: true,
              kisiler: [],
              fields: [
                  {key: 'isim', label: 'İsim', sortable: true},
                  {key: 'islemler', label: 'İşlemler'}
              ],
              kanaat: {
                  kisiId: 0,
                  metin: ''
              } 
            }
        },
        methods: {
            kanaatEkleVeyaDuzenle(kisiId, metin, index) {
                this.kanaat.kisiId = kisiId
                this.kanaat.metin = metin
                
                this.$bvModal.show('kanaatModal')
            },
            async kanaatiKaydet() {
                try {
                    const res = await KisiyeKanaatEkle(this.kanaat.kisiId, this.kanaat.metin)
                    this.$notify({
                        group: 'ust',
                        type: 'success',
                        title: 'Başarılı',
                        text: "İşleminiz başarılı bir şekilde gerçekleştirildi.",
                        duration: 3000
                    });
                    await this.verileriGetir()
                } catch (e) {
                    console.log(e)   
                }
                
            },
            kartlarinaGit(kisiId) {
                this.$router.push(`belgeler?tur=kart&id=${kisiId}`)
            },
            async verileriGetir() {
                try {
                    this.isBusy = true
                    const { data } = await SorumluOlunanKisileriGetir()
                    this.kisiler = data
                }
                finally {
                    this.isBusy = false
                }
            }
        },
        computed: {
            ...mapGetters([
                'girisYapmismi'
            ])
        },
        async created() {
            if (!this.girisYapmismi) {
                await new GoogleTokenIleGirisYapmayiDene(this);
            }
            
            if (!this.girisYapmismi) {
                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/sorumlu-olunan-kisiler"))
                }, 3000);
                return
            }
            await this.verileriGetir()
        }
    }
</script>

<style scoped>

</style>